import { computed, inject, ref } from 'vue';
import { defineStore } from 'pinia';
import baseAxios from 'axios';

import { AXIOS } from '../const';

import * as api from '../router/endpoints';

export const useValidationRuleStore = defineStore('validationRule', () => {
  const axios = inject(AXIOS) || baseAxios;

  const rules = ref([]);

  const TEXT_FIELD = 'text_field';
  const NUMBER_FIELD = 'number_field';
  const IDENTIFICATOR_FIELD = 'identificator_field';
  const DATE_FIELD = 'date_field';
  const BOOL_FIELD = 'bool_field';
  const GEO_LINE = 'geo_line';
  const GEO_POINT = 'geo_point';
  const GEO_POLYGON = 'geo_polygon';
  const GEO_CATALOG = 'geo_catalog';
  const CATALOG = 'catalog';
  const TABLE = 'table';

  const getValidationRulesRequest = ref({
    isLoading: false,
    isFinished: false,
    error: null
  });

  function getValidationRules(projectId) {
    getValidationRulesRequest.value = {};
    const req = getValidationRulesRequest.value;
    req.isLoading = true;

    return axios
      .get(api.validationRules({ projectId }))
      .then((resp) => {
        rules.value = resp.data;
      })
      .catch((e) => {
        req.error = e;
        throw e;
      })
      .finally(() => {
        req.isFinished = true;
        req.isLoading = false;
      });
  }

  return {
    rules,
    getValidationRulesRequest,
    getValidationRules,

    TEXT_FIELD,
    NUMBER_FIELD,
    DATE_FIELD,
    BOOL_FIELD,
    IDENTIFICATOR_FIELD,
    GEO_LINE,
    GEO_POINT,
    GEO_POLYGON,
    GEO_CATALOG,
    CATALOG,
    TABLE
  };
});
